// extracted by mini-css-extract-plugin
export default {"moduleWrapper":"People_moduleWrapper__okJDY","smallTitle":"People_smallTitle__2ZMAF","title":"People_title__JpnCY","gridWrapper":"People_gridWrapper__b7f1c"};